<template>
  <div class="divBox">
    <div
      v-for="(item, idx) in btns"
      :key="idx"
      :class="item.value === listType ? 'activeBtn' : 'defaultBtn'"
      @click="btnChange(item)"
    >
      {{ item.text }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'cardBtn',
    props: ['listType'],
    data() {
      return {
        btns: [
          { text: '卡片', value: '0' },
          { text: '列表', value: '1' },
        ],
      };
    },
    methods: {
      btnChange(item) {
        this.$emit('changeListType', item.value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .divBox {
    display: flex;
    flex-direction: row;
    margin-left: 10px;
  }
  .activeBtn {
    height: 32px;
    line-height: 32px;
    width: 60px;
    text-align: center;
    background-color: rgb(98, 153, 254);
    border: rgb(98, 153, 254);
    border-radius: 3px;

    color: #fff;
    cursor: pointer;
  }
  .defaultBtn {
    height: 32px;
    line-height: 32px;
    width: 60px;
    text-align: center;
    background-color: '#DCDFE6';
    border: '#DCDFE6';
    border-radius: 3px;
    color: #000;
    cursor: pointer;
  }
</style>
